export const SELECT_ALL_ITEMS_LENGTH_LIMIT = 200;
